export default "__VITE_ASSET__9851bb32__"